// import GameBookBtn from '../gameBookBtn';
import GameBook from '../gameBook';
import OpenGameBook from '../OpenGameBook';
import { GameBookType } from '@/_models/game/GameBook';
// import { TourType } from '@/_models/Tour';

export const GameBookHandle = ({ isEcommerce, gameBook, showBook, tourType, closeGameBook, unlockedChapterIds, moveToSweep, tryButtonPlaySound }: any) => {
  return (
    <>
      {/* {tourType === TourType.ECommerce && <GameBookBtn onToggle={onToggleGameBookModal} hide={!showBookBtn} />} */}
      {gameBook?.type === GameBookType.Close && showBook && (
        <GameBook
          tourType={tourType}
          show={showBook}
          onClose={closeGameBook}
          book={gameBook}
          unlockedChapterIds={unlockedChapterIds}
          tryButtonPlaySound={tryButtonPlaySound}
          moveToSweep={(sweepUuid, rotation) => {
            moveToSweep(sweepUuid, rotation);
            closeGameBook();
          }}
        />
      )}
      {gameBook?.type === GameBookType.Open && showBook && (
        <OpenGameBook show={showBook} onClose={closeGameBook} book={gameBook} unlockedChapterIds={unlockedChapterIds} moveToSweep={moveToSweep} tourType={tourType} />
      )}
    </>
  );
};
